module.exports = __webpack_public_path__ + "static/media/ios_install_instructions.8b7166b0.png";